module.exports = __webpack_public_path__ + "assets/582b86f45eedf37a36b315f618c74a7e.png";